















import { Vue, Component, Watch } from 'vue-property-decorator'
import { Button, Header, Container, Logo, Recaptcha } from '../atoms/'
import { EmailInputGroup } from '../molecules'
import { required, email } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import {
  USER_MODULE,
  REQUEST_RESET_PASSWORD,
  REQUEST_RESET_PASSWORD_ERROR,
  RESET_REQUEST_RESET_PASSWORD_ERROR
} from '../../store/modules/user/constant'
import { RequestResetPasswordPayload } from '../../store/api/type'
import { userWithEmailNotExist } from '../../utils/errors'
import { AUTH_MODULE, FORGOT_EMAIL_LOGIN } from '@/store/modules/auth/constant'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'
import translate from '@/language'

@Component({
  components: {
    Button,
    Container,
    Header,
    EmailInputGroup,
    Recaptcha,
    Logo
  },
  validations: {
    email: {
      required,
      email
    }
  },
  computed: {
    ...mapGetters(USER_MODULE, [REQUEST_RESET_PASSWORD_ERROR]),
    ...mapGetters(AUTH_MODULE, [FORGOT_EMAIL_LOGIN]),
    ...mapGetters(APP_MODULE, [TRANSLATE])
  },
  methods: {
    ...mapActions(USER_MODULE, [REQUEST_RESET_PASSWORD, RESET_REQUEST_RESET_PASSWORD_ERROR])
  }
})
export default class ForgotPassword extends Vue {
  private email = ''
  private recaptchaVisible?: boolean = false
  mounted() {
    this.email = this.forgotEmail;
    (this as any)[RESET_REQUEST_RESET_PASSWORD_ERROR]()
    this.$nextTick(() => {
      this.$v.$reset()
    })
  }

  @Watch('email')
  onEmailChange() {
    this.$v.email.$touch()
    return (this as any)[RESET_REQUEST_RESET_PASSWORD_ERROR]()
  }
  get showRegisterPrompt(): boolean {
    return this.requestResetPasswordError === userWithEmailNotExist
  }
  get requestResetPasswordError(): string {
    return (this as any)[REQUEST_RESET_PASSWORD_ERROR]
  }
  get emailError(): string {
    const { email: emailError } = this.$v
    if ((this as any)[REQUEST_RESET_PASSWORD_ERROR]) {
      return (this as any)[REQUEST_RESET_PASSWORD_ERROR]
    }
    if (emailError.$error) {
      if (!emailError.required) {
        return translate('', 'error-email-required')
      } else if (!emailError.email) {
        return translate('', 'error-email-invalid')
      }
    }
    return ''
  }
  get isEmailEror(): boolean {
    return this.emailError !== ''
  }
  get formError(): boolean {
    return this.$v.$invalid || this.isEmailEror
  }
  get enableRecaptcha(): boolean {
    return (process.env.VUE_APP_ENABLE_RECAPTCHA === 'true') as boolean
  }
  verifyWithRecaptcha() {
    if (this.enableRecaptcha) {
      this.recaptchaVisible = true
    } else {
      this.doRequestResetPassword('')
    }
  }
  async onRecaptchaVerify(verificationCipher: string) {
    this.recaptchaVisible = false
    this.doRequestResetPassword(verificationCipher)
  }
  async doRequestResetPassword(verificationCipher: string) {
    this.$v.$touch()
    if (!this.formError) {
      let channel: string | null
      const qsChannel = this.$route?.query?.channel

      if (Array.isArray(qsChannel)) {
        channel = qsChannel[0]
      } else if (typeof qsChannel === 'string') {
        channel = qsChannel
      } else {
        channel = null
      }

      const payload: RequestResetPasswordPayload = {
        email: this.email,
        cipher: verificationCipher,
        channel: channel
      }
      const resp = await (this as any)[REQUEST_RESET_PASSWORD](payload)
      if(resp.code == 200){
        this.$router.push({ path: '/forgot-password-sent'})
      }
    }
  }
  get forgotEmail(): string {
    return (this as any)[FORGOT_EMAIL_LOGIN]
  }
}
